import { render, staticRenderFns } from "./HeaderLayout.vue?vue&type=template&id=5caa0b1c&scoped=true&"
import script from "./HeaderLayout.vue?vue&type=script&lang=js&"
export * from "./HeaderLayout.vue?vue&type=script&lang=js&"
import style0 from "./HeaderLayout.vue?vue&type=style&index=0&id=5caa0b1c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5caa0b1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/myretro/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5caa0b1c')) {
      api.createRecord('5caa0b1c', component.options)
    } else {
      api.reload('5caa0b1c', component.options)
    }
    module.hot.accept("./HeaderLayout.vue?vue&type=template&id=5caa0b1c&scoped=true&", function () {
      api.rerender('5caa0b1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/HeaderLayout.vue"
export default component.exports